import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import brandLockupSrc from '~/assets/images/evisort-workday-logo.svg';
import { BRAND_NAME } from '~/common/constants/brand';
import { RoutePathType } from '~/routing/enums';

import { useNavLinkActivate } from './useNavLinkActivate';

const messages = defineMessages({
  goHome: {
    id: 'AppBreadcrumb.goHome',
    defaultMessage: 'Go to home',
    description:
      'Accessible label for the logo button that navigates to the home page.',
  },
});

/** The brand link home, as the top bar and the mobile drawer header show it. */
export function useAppNavBrand(testId: string) {
  const intl = useIntl();
  const onActivate = useNavLinkActivate();

  return useMemo(
    () => ({
      dataAttributes: {
        'data-amp-track-item': 'logo-home-link',
        'data-testid': testId,
      },
      href: RoutePathType.Home,
      label: intl.formatMessage(messages.goHome),
      logo: (
        <img
          alt={BRAND_NAME}
          decoding="sync"
          fetchPriority="high"
          height={18}
          loading="eager"
          src={brandLockupSrc}
          width={96}
        />
      ),
      onActivate,
    }),
    [intl, onActivate, testId],
  );
}
